const UnreadMessageIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.7469 21.5521 15.3892 20.7648 16.8183C20.6448 16.8062 20.5231 16.8 20.4 16.8C18.4133 16.8 16.8 18.4133 16.8 20.4C16.8 20.5231 16.8062 20.6448 16.8183 20.7648C15.3892 21.5521 13.7469 22 12 22H3.86159C2.72736 22 2.00986 20.7933 2.53406 19.8016L3.38777 17.9647C3.5333 17.6516 3.50372 17.2874 3.33127 16.9883C2.48451 15.5196 2 13.8153 2 12ZM9.3002 12C9.3002 12.7179 8.71817 13.3 8.0002 13.3C7.28223 13.3 6.7002 12.7179 6.7002 12C6.7002 11.282 7.28223 10.7 8.0002 10.7C8.71817 10.7 9.3002 11.282 9.3002 12ZM17.3002 12C17.3002 12.7179 16.7182 13.3 16.0002 13.3C15.2822 13.3 14.7002 12.7179 14.7002 12C14.7002 11.282 15.2822 10.7 16.0002 10.7C16.7182 10.7 17.3002 11.282 17.3002 12ZM13.3002 12C13.3002 12.7179 12.7182 13.3 12.0002 13.3C11.2822 13.3 10.7002 12.7179 10.7002 12C10.7002 11.282 11.2822 10.7 12.0002 10.7C12.7182 10.7 13.3002 11.282 13.3002 12Z"
        fill="#57585C"
      />
      <path
        d="M20.4 18.4004C19.2963 18.4004 18.4 19.2967 18.4 20.4004C18.4 21.5041 19.2963 22.4004 20.4 22.4004C21.5038 22.4004 22.4 21.5041 22.4 20.4004C22.4 19.2967 21.5038 18.4004 20.4 18.4004Z"
        fill="#57585C"
      />
    </svg>
  );
};

export default UnreadMessageIcon;
